import * as Yup from "yup"
import {
  enterpriseTitleLengthMaxCount,
  enterpriseTitleLengthMaxError,
  enterpriseTitleLengthMinCount,
  enterpriseTitleLengthMinError,
  enterpriseTitleRequiredError,
  firstNameLengthMaxCount,
  firstNameLengthMaxError,
  itemCountMinCount,
  itemCountMinError,
  itemCountRequiredError,
  itemNumberMinCount,
  itemNumberMinError,
  itemNumberRequiredError,
  itemTitleLengthMaxCount,
  itemTitleLengthMaxError,
  itemTitleLengthMinCount,
  itemTitleLengthMinError,
  itemTitleRequiredError,
  itemTypeOfCountAllowError,
  itemTypeOfCountCount,
  itemTypeOfCountRequiredError,
  itemTypeOfCountWeight,
  lastNameLengthMaxCount,
  lastNameLengthMaxError,
  orderSourceTypeItems,
  orderSourceTypeOthers,
  orderSourceTypeSales,
  orderSourceTypeShopPaymentPoints,
  orderSourceTypeShops,
  orderSourceTypeShopSalePoints,
  orderSourceTypeUsers,
  orderSumMinCount,
  orderSumMinError,
  orderSumRequiredError,
  orderTypeOrderAdd,
  orderTypeOrderRemove,
  passwordLengthMaxCount,
  passwordLengthMaxError,
  passwordLengthMinCount,
  passwordLengthMinError,
  passwordRequiredError,
  patronymicLengthMaxCount,
  patronymicLengthMaxError,
  shopPaymentPointTypeOfPaymentAllowError,
  shopPaymentPointTypeOfPaymentCard,
  shopPaymentPointTypeOfPaymentCash,
  shopPaymentPointTypeOfPaymentQr,
  shopPaymentPointTypeOfPaymentRequiredError,
  shopTitleLengthMaxCount,
  shopTitleLengthMaxError,
  shopTitleLengthMinCount,
  shopTitleLengthMinError,
  shopTitleRequiredError,
  titleLengthMaxCount,
  titleLengthMaxError,
  titleLengthMinCount,
  titleLengthMinError,
  titleRequiredError,
  usernameLengthMaxCount,
  usernameLengthMaxError,
  usernameLengthMinCount,
  usernameLengthMinError,
  usernameRequiredError,
  uuidLengthCount,
  uuidRequiredError,
} from "./vars"

// ---------------------------------------------

export const RegExpDateLayout = new RegExp("\\d{4}-\\d{2}-\\d{2}")

// ---------------------------------------------

export const UuidRequired = Yup.string()
  .required(uuidRequiredError)
  .length(uuidLengthCount)

export const Uuid = Yup.string().length(uuidLengthCount)

export const titleValidation = Yup.string()
  .required(titleRequiredError)
  .min(titleLengthMinCount, titleLengthMinError)
  .max(titleLengthMaxCount, titleLengthMaxError)

export const SearchTextValidation = Yup.string()

export const UsernameValidation = Yup.string()
  .required(usernameRequiredError)
  .min(usernameLengthMinCount, usernameLengthMinError)
  .max(usernameLengthMaxCount, usernameLengthMaxError)

export const PasswordValidation = Yup.string()
  .required(passwordRequiredError)
  .min(passwordLengthMinCount, passwordLengthMinError)
  .max(passwordLengthMaxCount, passwordLengthMaxError)

export const FirstNameValidation = Yup.string().max(
  firstNameLengthMaxCount,
  firstNameLengthMaxError
)

export const LastNameValidation = Yup.string().max(
  lastNameLengthMaxCount,
  lastNameLengthMaxError
)

export const PatronymicValidation = Yup.string().max(
  patronymicLengthMaxCount,
  patronymicLengthMaxError
)

export const EnterpriseTitleValidation = Yup.string()
  .required(enterpriseTitleRequiredError)
  .min(enterpriseTitleLengthMinCount, enterpriseTitleLengthMinError)
  .max(enterpriseTitleLengthMaxCount, enterpriseTitleLengthMaxError)

export const ShopTitleValidation = Yup.string()
  .required(shopTitleRequiredError)
  .min(shopTitleLengthMinCount, shopTitleLengthMinError)
  .max(shopTitleLengthMaxCount, shopTitleLengthMaxError)

export const ItemExternalIDValidation = Yup.string()

export const ItemBarcodeValidation = Yup.string()

export const ItemTitleValidation = Yup.string()
  .required(itemTitleRequiredError)
  .min(itemTitleLengthMinCount, itemTitleLengthMinError)
  .max(itemTitleLengthMaxCount, itemTitleLengthMaxError)

export const ItemCountValidation = Yup.number()
  .required(itemCountRequiredError)
  .min(itemCountMinCount, itemCountMinError)

export const ItemTypeOfCountValidation = Yup.string()
  .required(itemTypeOfCountRequiredError)
  .oneOf(
    [itemTypeOfCountWeight, itemTypeOfCountCount],
    itemTypeOfCountAllowError
  )

export const ItemNumberValidation = Yup.number()
  .required(itemNumberRequiredError)
  .min(itemNumberMinCount, itemNumberMinError)

export const ItemNumberPositiveValidation = Yup.number()
  .required(itemNumberRequiredError)
  .positive()

// Order

export const OrderTypeOrderValidation = Yup.string()
  .required(orderSumRequiredError)
  .oneOf([orderTypeOrderAdd, orderTypeOrderRemove])

export const OrderReasonValidation = Yup.string()

export const OrderSumValidation = Yup.number()
  .required(orderSumRequiredError)
  .min(orderSumMinCount, orderSumMinError)

export const OrderSourceTypeValidation = Yup.string()
  .required()
  .oneOf([
    orderSourceTypeShops,
    orderSourceTypeItems,
    orderSourceTypeUsers,
    orderSourceTypeSales,
    orderSourceTypeOthers,
    orderSourceTypeShopSalePoints,
    orderSourceTypeShopPaymentPoints,
  ])

// Shop

export const ShopPaymentPointTypeOfPaymentValidation = Yup.string()
  .required(shopPaymentPointTypeOfPaymentRequiredError)
  .oneOf(
    [
      shopPaymentPointTypeOfPaymentCash,
      shopPaymentPointTypeOfPaymentCard,
      shopPaymentPointTypeOfPaymentQr,
    ],
    shopPaymentPointTypeOfPaymentAllowError
  )

// Sale

export const SaleDateOperationValidation =
  Yup.string().matches(RegExpDateLayout)

export const SaleFromDateValidation = Yup.string().matches(RegExpDateLayout)

export const SaleToDateValidation = Yup.string().matches(RegExpDateLayout)
